const navs = [
  { id: "live", label: "现场直击" },
  { id: "events", label: "热门事件" },
  { id: "themes", label: "主题图集" },
  { id: "gallery", label: "高清生图" },
  { id: "collections", label: "精选合集" },
  { id: "about", label: "关于图集" },
];

export default function SectionHeading({
  kicker,
  title,
  desc,
  accent,
  align = "left",
}: {
  kicker: string;
  title: string;
  desc?: string;
  accent?: boolean;
  align?: "left" | "center";
}) {
  return (
    <div
      className={
        align === "center"
          ? "flex flex-col items-center text-center"
          : "flex flex-col items-start"
      }
    >
      <span
        className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap ${
          accent
            ? "bg-accent-500/90 text-background-50"
            : "bg-primary-500 text-background-50"
        }`}
      >
        <span className="w-1.5 h-1.5 rounded-full bg-current"></span>
        {kicker}
      </span>
      <h2 className="mt-4 text-2xl md:text-4xl font-heading font-bold tracking-tight text-foreground-950">
        {title}
      </h2>
      <span className="mt-3 h-1 w-16 rounded-full bg-primary-500"></span>
      {desc ? (
        <p className="mt-4 max-w-2xl text-sm md:text-base leading-relaxed text-foreground-600">
          {desc}
        </p>
      ) : null}
    </div>
  );
}